import { generateHTML } from '@tiptap/html';
import { JSONContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { ImageResize } from '../ImageExtension/ImageResize';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import Link from '@tiptap/extension-link';
import Table from '../table';
/**
 * Generates HTML content from a given string or JSONContent.
 * @param content - The content to generate HTML from.
 * @returns The generated HTML content.
 */
export function generateHTMLFromEditorContent(content?: string | JSONContent) {
  console.log({ content });
  const jsonContent =
    typeof content === 'string' ? JSON.parse(content) : content;
  console.log({ jsonContent });
  return generateHTML(jsonContent, [
    StarterKit,
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    ImageResize,
    Table.configure({
      resizable: true,
      HTMLAttributes: {
        class: 'summary-table',
      },
    }),
    TableRow,
    TableHeader,
    TableCell,
    Link,
  ]);
}
